unit WEBLib.TMSFNCCommonJSFiles;

interface

implementation
{$R webfilesCommonJS.res}

end.
